module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加属性 prop:content")])]), _vm._v(" "), _c('h2', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:is-loading 显示加载图标，适用于异步加载数据的场景")])]), _vm._v(" "), _c('h2', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 在 nextTick 回调渲染 picker 避免赋值报错 #1180")])]), _vm._v(" "), _c('h2', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 resize 事件没有移除导致切换页面报错 #1183")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复滚动情况下跳转页面报错 #1187")])]), _vm._v(" "), _c('h2', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复disabled时不能上下滚动问题")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复disabled时，安卓手机上不能触发点击事件的问题")])]), _vm._v(" "), _c('h2', [_vm._v("XIcon")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持传任意属性 #1147")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-88991626", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-88991626"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/next_zh-CN-279.vue
// module id = 2935
// module chunks = 519